import Axios from "axios";
import React, { useEffect, useState } from "react";
import Iframe from "react-iframe";

const PayfastPayment = ({ requestModel, callback }) => {
    console.log("requestModel", requestModel);
    const [paymentUrl, setPaymentUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // useEffect(() => {
    //     const fetchTokenAndPaymentUrl = async () => {
    //         try {
    //             // Fetch token
    //             const tokenResponse = await getPayfastToken(requestModel.txnAmt, requestModel.basketId);
    //             const token = tokenResponse.accessToken;

    //             console.log("Token fetched successfully:", token);

    //             // Prepare payment request
    //             const paymentRequest = {
    //                 MERCHANT_ID: requestModel.merchantId,
    //                 MERCHANT_NAME: requestModel.merchantName,
    //                 TOKEN: "-hJvwaxIlCO7AFOeVgS52aBbAJ89ryFQ8cyLedz8Z70",
    //                 PROCCODE: requestModel.procCode,
    //                 TXNAMT: requestModel.txnAmt,
    //                 CUSTOMER_MOBILE_NO: requestModel.customerMobileNo,
    //                 CUSTOMER_EMAIL_ADDRESS: requestModel.customerEmailAddress,
    //                 SIGNATURE: requestModel.signature,
    //                 VERSION: requestModel.version,
    //                 TXNDESC: requestModel.txnDesc,
    //                 SUCCESS_URL: requestModel.successUrl,
    //                 FAILURE_URL: requestModel.failureUrl,
    //                 BASKET_ID: requestModel.basketId,
    //                 ORDER_DATE: requestModel.orderDate,
    //                 CHECKOUT_URL: requestModel.checkoutUrl,
    //                 CURRENCY_CODE: requestModel.currencyCode,
    //                 CUSTOMER_NAME: requestModel.customerName,
    //                 MERCHANT_CUSTOMER_ID: requestModel.merchantCustomerId,
    //                 COUNTRY: requestModel.country,
    //             };

    //             // Call the payment API
    //             const response = await fetch("https://ipg1.apps.net.pk/Ecommerce/api/Transaction/PostTransaction", {
    //                 method: "POST",
    //                 headers: {
    //                     "Content-Type": "application/x-www-form-urlencoded",
    //                 },
    //                 body: new URLSearchParams(paymentRequest),
    //             });

    //             const data = await response.json();
    //             setPaymentUrl(data.paymentUrl);
    //             setLoading(false);
    //         } catch (error) {
    //             setError("Payment error: " + error.message);
    //             setLoading(false);
    //         }
    //     };

    //     fetchTokenAndPaymentUrl();
    // }, [requestModel]);

    useEffect(() => {
        const submitForm = async () => {
            try {
                // Create a form dynamically and submit it
                const form = document.createElement("form");
                form.method = "POST";
                form.action = "https://ipg1.apps.net.pk/Ecommerce/api/Transaction/PostTransaction";

                // Add all requestModel fields to the form
                Object.entries(requestModel).forEach(([key, value]) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                });

                // Append form to body and submit it
                document.body.appendChild(form);
                form.submit();
            } catch (error) {
                console.error("Error submitting form:", error);
                setError("An error occurred while submitting the payment form.");
            }
        };

        // Check if requestModel is valid before submitting
        if (requestModel && Object.keys(requestModel).length > 0) {
            submitForm();
        } else {
            console.error("Request model is empty or invalid.");
        }
    }, [requestModel]);

    return <div>Redirecting to payment page...</div>;

    const handleIframeLoad = (event) => {
        const path = new URL(event.target.src).pathname;

        if (path.includes("/Ecommerce/Payfast/CardInfo")) {
            setLoading(false);
        }

        if (path.includes("/Ecommerce/scheme/TransactionFailurePage") || path.includes("/Ecommerce/scheme/TransactionSuccessPage")) {
            if (callback) callback();
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return <div>{paymentUrl && <Iframe url={paymentUrl} width="100%" height="500px" onLoad={handleIframeLoad} display="initial" position="relative" />}</div>;
};

const getPayfastToken = async (amount, basketId) => {
    try {
        const response = await Axios.post(
            "https://ipg1.apps.net.pk/%27/Ecommerce/api/Transaction/GetAccessToken",
            {
                MERCHANT_ID: "16590",
                SECURED_KEY: "vhlNYippf-v0oKT1lhMBdjkJ",
                BASKET_ID: basketId,
                TXNAMT: amount.toString(),
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        console.log(response.data, "Token API Response");
        return response.data; // Return the token response
    } catch (error) {
        console.error("Error fetching PayFast token:", error);
        throw new Error("Error fetching PayFast token: " + error.message);
    }
};

export default PayfastPayment;
